// @flow

import { injectGlobal } from 'styled-components';

const theme = {
  typography: {
    family: '"Roboto", sans-serif',
    size: {
      yuge: '50px',
      title: '26px',
      large: '20px',
      standardAlt: '16px',
      standard: '14px',
      medium: '12px',
      smallAlt: '11px',
      small: '10px',
    },
  },
  colors: {
    // TODO: make these names more generic for theming
    black: '#000000',
    black20: 'rgba(0,0,0,0.2)',
    black60: 'rgba(0,0,0,0.6)',
    blueyGrey: '#90a4ae',
    dark: '#29343d',
    lightGreyTranslucent: 'rgba(144,144,144,0.15)',
    paleGrey: '#fafbfb',
    primary: '#ee9d36',
    primary5: 'rgba(238,157,54,0.5)',
    primaryHover: '#e19433',
    secondary: '#241f20',
    silver: '#cfd8dc',
    slateGrey: '#58585a',
    tomato: '#f44336',
    tomato5: 'rgba(244,67,54,0.05)',
    tomatoDark: '#A90F03',
    white: '#ffffff',
    white50: 'rgba(255,255,255,0.5)',
  },
  spacing: {
    tiny: '5px',
    small: '10px',
    standard: '20px',
    wide: '32px',
  },
  mediaQueries: {
    // effectively disable any mobile behavior hooks for now
    small: '(max-width: 0px)',
    // small: '(max-width: 600px)',
    large: '(max-width: 1000px)',
  },
};

/* eslint-disable no-unused-expressions */
injectGlobal`
  *, *::after, *::before { box-sizing: border-box; }
  body {
    background: ${theme.colors.paleGrey};
    font-family: ${theme.typography.family};
    margin: 0;
    overflow-x: hidden;
    padding: 0;
  }
`;
/* eslint-enable no-unused-expressions */

export default theme;



// WEBPACK FOOTER //
// ./src/theme.js